import { Link } from "react-router-dom";
import { Reveal, PageShell } from "@/components/Reveal";

export default function Cookies() {
  return (
    <PageShell testid="cookies-page">
      <header
        data-testid="cookies-hero"
        className="px-6 pb-12 pt-36 md:px-12 md:pb-16 md:pt-52"
      >
        <div className="mx-auto max-w-3xl">
          <p className="mb-6 text-xs uppercase tracking-[0.4em] text-anthrazit/60">
            Dein Körper spricht mit dir
          </p>
          <h1 className="font-serif text-5xl leading-[0.95] tracking-tight text-anthrazit md:text-7xl">
            Cookies
          </h1>
        </div>
      </header>
      <section data-testid="cookies-content" className="px-6 pb-32 md:px-12 md:pb-44">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <h2 className="font-serif text-2xl tracking-tight text-anthrazit md:text-3xl">
              Cookie-Richtlinie
            </h2>
            <div className="mt-8 space-y-4">
              <p className="text-base leading-relaxed text-anthrazit/85">
                Diese Website verwendet technisch notwendige Cookies und Technologien, die für den Betrieb der Website erforderlich sind.
              </p>
              <p className="text-base leading-relaxed text-anthrazit/85">
                Darüber hinaus können externe Inhalte von Google Maps und YouTube eingebunden werden. Diese werden erst nach deiner Einwilligung geladen.
              </p>
              <p className="text-base leading-relaxed text-anthrazit/85">
                Du kannst deine Cookie-Einstellungen jederzeit über „Cookie-Einstellungen“ ändern oder deine Einwilligung widerrufen.
              </p>
              <p className="text-base leading-relaxed text-anthrazit/85">
                Weitere Informationen zur Verarbeitung personenbezogener Daten findest du in unserer{" "}
                <Link
                  data-testid="cookies-datenschutz-link"
                  to="/datenschutz"
                  className="underline underline-offset-4 transition-colors hover:text-anthrazit"
                >
                  Datenschutzerklärung
                </Link>
                .
              </p>
            </div>
            <div className="mt-12">
              <h3 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                Verantwortlich:
              </h3>
              <p
                data-testid="cookies-verantwortlich"
                className="text-base leading-relaxed text-anthrazit/85"
              >
                Carmen Hackradt
                <br />
                Sehestedter Str. 10
                <br />
                24340 Eckernförde
                <br />
                E-Mail: kontakt@carmenhackradt.de
                <br />
                Telefon: 0162 8564347
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </PageShell>
  );
}
